import {
 obtenerConsulta,
  obtenerMetacamposColl,
  obtnerMetacamposCollection,
  obtenerConsultaProducto,
  agregaProductosAlCarrito,
  ejecutarConsulta
} from "./peticiones_store_front3.js";
const SHOP= "turismopanaca.myshopify.com",
      ID_COLLECTION = 416418496750,
      ID_FINCAS_CAFETERAS= 416851755246,
      ID_LUXURY= 426495443182,
      ID_GLAMPING_ECO= 426494427374,
      ID_CAMPESTRES =417971372270,
      ID_CAMPESTRES_PREMIUM= 427305042158,
      ID_RESORT=413436510446,
      ID_URBANOS=427305631982,
      ID_FINCAS_PRIVADAS=426202366190,
      URL_DISPONIBILIDAD = "https://izyrent.speaz.com/front/get_availabilities";
      let hotels = [];
showLoading();

 let arreglo ={
    "items": [
        {
            "id": "44183266525422",
            "quantity": "0",
            "properties": {
                "fecha": "2024/12/06",
                "group": "event"
                
            }
        },
        
    ]
};
//fucncion para la carga de hoteles


//funcion par invertir las fechas
const fechaAnioMesDia = (fecha)=>{
  const arryFecha = fecha.split("-");
  let anioMesDia = arryFecha[2]+"/"+arryFecha[1]+"/"+arryFecha[0];
  return anioMesDia;
  
}

let reserva =  JSON.parse(sessionStorage.getItem('reserva'));

//funcion para definir en que colecion buscar
const getIdColeccion = (categoria)=>{
  let colecion = ID_COLLECTION;
  
  switch(categoria){
    case 'cafeteras':
        colecion = ID_FINCAS_CAFETERAS;
      break;
      
    case 'luxury':
      colecion = ID_LUXURY;
      break;
      
    case 'glamping':
      colecion = ID_GLAMPING_ECO;
      break;

    case 'campestres':
      colecion = ID_CAMPESTRES;
      break;

   case 'premium':
      colecion = ID_CAMPESTRES_PREMIUM;
      break;

    case 'resort':
      colecion = ID_RESORT;
      break;

    case 'urbanos':
      colecion = ID_URBANOS;
      break;

    case 'privadas':
      colecion = ID_FINCAS_PRIVADAS;
      break;

        case 'pereira':
      colecion = ID_FINCAS_PRIVADAS;
      break;
      

      
      
  }

  return colecion;
}



//funcion para obtener los parametro para realizar los filtros
const obtenerParametros = async (obtnerDisponibilidad) =>{
  
  const reserva = await JSON.parse(sessionStorage.getItem('reserva')),
        numeroAdultos      = reserva.totalAdultos,
        numeroNinos        = reserva.totalNinos,
        numeroHabitaciones = reserva.acomodacion.length,
        fechaIngreso       = fechaAnioMesDia(reserva.fechaLlegada),
        fechaEgreso        = fechaAnioMesDia(reserva.fechaSalida),
        indice             = reserva.categoriaIndice,
        categoria          = reserva.categoria,
        mascotas = reserva.mascotas,
        numMascotas = reserva.numMascotas;
 const $checkin            = document.querySelector(".section-cotizador__checkin");
 const $checkout           = document.querySelector(".section-cotizador__checkout");
 const $numperson          = document.querySelector(".section-cotizador__persons");
 const $categoria          =  document.querySelector(".section-cotizador__select-category");


       $checkin.textContent = reserva.fechaLlegada;
       $checkout.textContent = reserva.fechaSalida;
       $numperson.textContent = `${numeroAdultos} Adultos ${numeroNinos} Niños ${numeroHabitaciones} Habitacion`;
     setTimeout(() => {
  
      $categoria.options[indice].selected = true; 
}, 3000);
  
  
  
  obtnerDisponibilidad(fechaIngreso, fechaEgreso,  categoria, numMascotas );
  
  
}

//agrupa las habitaciones por hoteles
const groupRooms = (rooms) => {
  const group = rooms.reduce((previus, current) => {
    const key = current.tags[0].replace("#", "");
    if (!previus[key]) {
      previus[key] = [];
    }
    previus[key].push(current);
    return previus;
  }, {});

  return group;
};

//funcion para ver a que temporada pertenece la fecha selecionada queda a la esperea por duda si se realiza reserva dia antes del cambio de temporada como e hare el manejo
  const searchDateInRange = (startDate, endDate, dateCheckin) => {
    return dateCheckin >= startDate && dateCheckin <= endDate;
  }

const findeSemana = (fechaInicio, fechaFin) =>{
  let fechaActual = moment(fechaInicio);
    const fechaFinal = moment(fechaFin);

  while(fechaActual <= fechaFinal){
    const numeroDiaSemana = fechaActual.day();
    if(numeroDiaSemana === 5 || numeroDiaSemana === 6){
       return true;
    }
    fechaActual.add(1, 'day');
  }
  return false;
}

//funcion para obtener las temporadas de cada hotel
const obtenerFechaTemporada = (temporadas, fecha, nombreHotel,  checkout) =>{
    let temporada = "";
    let media = findeSemana(fecha.replace(/\//g, "-"), checkout.replace(/\//g, "-"));
   
  
  
   if (nombreHotel === "las_camelias" && media && fecha.split("/")[1] !== "12" && fecha.split("/")[1] !== "01" && fecha.split("/")[1] !== "10") {

      fecha = '2024/08/10'
    } 

   

  for (let indice = 0; indice < temporadas.length; indice++){
    let existe = searchDateInRange(temporadas[indice].fecha_inicio, temporadas[indice].fecha_fin, fecha.replaceAll('/', '-'));

     if(existe){
       temporada = temporadas[indice];
       break;
     }else{
       
       continue;
     }
  
  }
  
  return temporada;
}


//funcion para obtener los metacampos de las coleciones
const obtenerMetacampos = async (nombreColecion, fecha,  checkout) =>{

  const  todosHoteles   =  JSON.parse(sessionStorage.getItem("hoteles"));
  let    existe         =  todosHoteles.find(colecion => colecion.handle == nombreColecion.replaceAll("_", "-"));
  let    metacampos     =  existe.metafields;
  let    id             =  existe.id;
  let    temporada      =  await obtenerFechaTemporada(existe.metafields.seasons, fecha, nombreColecion,  checkout);
  let    imagen         =  existe.image;

  return{
    temporada, 
    metacampos,
    imagen,
    id
  };
}

  //funcion para ordenar las habitaciones por capacidad
const sortedRoom = (room1, room2) => {
    return room1.tags[1] - room2.tags[1];
    
 }

/*const verDisponibilidad = (habitaciones, numPersona) =>{
  let room = {};

    let roomExist = habitaciones.find((room) => parseInt(room.tags[1]) == numPersona);
     let  index  = -1;
    //index = habitaciones.findIndex((room) => parseInt(room.tags[1]) === numPersona);

    if (roomExist) {
      index = habitaciones.indexOf(roomExist);
      room.ulrProduct = roomExist.onlineStoreUrl;
      room.index =  index;

    } else {
      let nextCapacity = habitaciones.find((room) => parseInt(room.tags[1]) > numPersona),
        index = habitaciones.indexOf(nextCapacity);

      if (nextCapacity) {
        room.ulrProduct = nextCapacity.onlineStoreUrl;
        room.index = index;

      }

    }

    return room;
  
}*/

const verDisponibilidad = (habitaciones, numPersona) =>{
  let room = {};

    let roomExist = habitaciones.find((room) => parseInt(room.tags[1]) == numPersona);
     let  index  = -1;
    //index = habitaciones.findIndex((room) => parseInt(room.tags[1]) === numPersona);

    if (roomExist) {
      index = habitaciones.indexOf(roomExist);
      room.ulrProduct = roomExist.onlineStoreUrl;
      room.index =  index;

    } else {
      let nextCapacity = habitaciones.find((room) => parseInt(room.tags[1]) > numPersona),
        index = habitaciones.indexOf(nextCapacity);

      if (nextCapacity) {
        room.ulrProduct = nextCapacity.onlineStoreUrl;
        room.index = index;

      }

    }

    return room;
  
}
//funcion para calcular el numero de total de personas dependiendo de las edades de los niños
  const getNumberPerson = (agesChildren, minimalAgeHotel) => {
    let childPay = 0;
  
    for (let index = 0; index < agesChildren.length; index++) {
      if (parseInt(agesChildren[index]) >= parseInt(minimalAgeHotel)) {
        childPay += 1;
      }
    }
    return childPay;
  }



//funcion para obtener el id de una colecion dado el titulo
  const getCollectioByTitle = async (title) => {

    try {

      let resp = await fetch(window.Shopify.routes.root + `collections/${title}.json`);
      let json = await resp.json();
  
      return json;

    } catch (err) {
      console.log(err);
    }

  }

const totalPersonasPagan = async (nombreHotel, edades) =>{

    const hoteles = JSON.parse(sessionStorage.getItem('hoteles'));
    let idHotel = await getCollectioByTitle(nombreHotel.replaceAll('_', '-').replaceAll("#",""));
    const hotel = await  hoteles.find((element) => element.id == idHotel.collection.id);

   if (hotel) {
      const minimalAge = hotel.metafields.child_minimal_age;
      return getNumberPerson(edades, hotel.metafields.child_minimal_age);
    
    }
}

const cantidadPersonasHabitacion = async (habitacionBuscada, habitacionesHotel, edadMinimaNinos) =>{
 habitacionesHotel.sort(sortedRoom)

  if(habitacionesHotel.length > 0){
    let ninosPagan = await totalPersonasPagan(habitacionesHotel[0].tags[0], habitacionBuscada.ninos );
    let capacidadRequerida = await verDisponibilidad( habitacionesHotel, (ninosPagan +parseInt(habitacionBuscada.adultos)));
      if (Object.keys(capacidadRequerida).length != 0) {
     
        //habitacionesHotel.splice(capacidadRequerida.index, 1);
        return capacidadRequerida.ulrProduct;

      }
    
  }
}
//funcion para ver las variantes de los productos selecionados
  const getVariants = async (urlProduct) => {
    let patName = new URL(urlProduct);

    try {
      let response = await fetch(`${patName}.js`),
        json = await response.json();
 
      return json;
    } catch {
      console.log("error")
    }
  }

  //funcion para encontrar la variante con respecto a la temporada
  const getVariantSelect = (variants, season) => {
    const variantRoom = [];
    for (let index = 0; index < variants.variants.length; index++) {
      if (variants.variants[index].title.includes(season.temporada.split('_')[1])) {
        variantRoom.push(variants.variants[index]);

      }

    }
    return variantRoom;
  }

//funcion para calcular el numero de noches de la reserva
  const getNumberNight = () => {
    let dayInMilesecond = 24 * 60 * 60 * 1000,
        reserva = JSON.parse(sessionStorage.getItem('reserva')),
        $checkin = reserva.fechaLlegada,
        $checkout = reserva.fechaSalida,
        starDate = new Date(fechaAnioMesDia($checkin)),
        endDate = new Date(fechaAnioMesDia($checkout)),
        difference = Math.round((endDate - starDate) / dayInMilesecond);

    return difference;

  }

//funcion para calcular el numero de noches de la reserva
  const obtenerNumeroNoches = (checkin, checkout) => {
    let dayInMilesecond = 24 * 60 * 60 * 1000,
        $checkin = checkin,
        $checkout = checkout,
        starDate = new Date(fechaAnioMesDia($checkin)),
        endDate = new Date(fechaAnioMesDia($checkout)),
        difference = Math.round((endDate - starDate) / dayInMilesecond);

    return difference;

  }


  //funcion para consultar las variantes de las habitaciones encontradas
  const getVariantRoom = async (rooms, season, hotel, image) => {

    let variantSelect = [];
    for (let index = 0; index < rooms.length; index++) {
      
      let variants = await getVariants(rooms[index]),
        variant = await getVariantSelect(variants, season);
      variantSelect.push(variant)
    }

    getNumberNight();
 

    const hotelSlect = {
      hotelName: hotel,
      image,
      hotelNight: getNumberNight(),
      variant: variantSelect,
    }
   
    hotels.push(hotelSlect);

  }


//funcion para recorrer las habitaciones de cada hotel buscando la ocupación solicitada
const obtenerHabitaciones = async (habitacionesHotel,temporada, metacamposHotel, imagen, idHotel, busquedaConMascota) =>{
  const HabitacionesHoteles = [];
    const copiaHabitaciones = [...habitacionesHotel];
    const reserva =  JSON.parse(sessionStorage.getItem('reserva'));
    const  numeroHabitaciones = reserva.acomodacion.length;
    const habitaciones = reserva.acomodacion;
  
  for (let index = 0; index < numeroHabitaciones; index++) {
    if(copiaHabitaciones.length >= numeroHabitaciones){
      let habitacion = await cantidadPersonasHabitacion(habitaciones[index], habitacionesHotel, metacamposHotel.child_minimal_age);
      if(habitacion){
        
        HabitacionesHoteles.push(habitacion);
      }
    }
  }

  
  let hotelName = copiaHabitaciones[0].tags[0].replace('#', '');   
    if (HabitacionesHoteles.length > 0 &&  numeroHabitaciones  == HabitacionesHoteles.length) {
        
       getVariantRoom(HabitacionesHoteles, temporada, hotelName, imagen);
      
       await createCardHotel(hotelName, imagen, metacamposHotel,  idHotel, busquedaConMascota, temporada );
      setTimeout(()=>{
       hiddenLoanding(); 
        hiddenLoanding();
        
      }, 500);
      

    }
  
  
}


//funcion paracrear las targetas de los hoteles
const  createCardHotel = (nombreHotel, imagen, metacampos, idHotel, busquedaConMascota, temporada) =>{
console.log("los metacampos", metacampos);
  const $templateCarHotel = document.querySelector("#card-hotel").content,
        $fragmentCardHotel = document.createDocumentFragment(),
        $contenedor = document.querySelector(".cards-hoteles"),
        reserva = JSON.parse(sessionStorage.getItem('reserva')),
        numeroAdultos      = reserva.totalAdultos,
        numeroNinos        = reserva.totalNinos,
        numeroHabitaciones = reserva.acomodacion.length,
        fechaIngreso       = fechaAnioMesDia(reserva.fechaLlegada),
        fechaEgreso        = fechaAnioMesDia(reserva.fechaSalida);

    let temporadaBusqueda = temporada.temporada.split("_")[1];
   
  $templateCarHotel.querySelector(".cards-hoteles__img").setAttribute("src", `https://cdn.shopify.com/s/files/1/0654/4562/6094/${imagen}`);
  $templateCarHotel.querySelector(".cards-hoteles__category").textContent = metacampos.type;
  $templateCarHotel.querySelector(".cards-hoteles__name").textContent = nombreHotel.replaceAll("_", " ");
  $templateCarHotel.querySelector(".card-hotel__input-checkin").textContent = reserva.fechaLlegada.replaceAll("-", " | ");
  $templateCarHotel.querySelector(".card-hotel__input-checkout").textContent = reserva.fechaSalida.replaceAll("-", " | ");
  $templateCarHotel.querySelector(".cards-hoteles_numpereson").textContent = `${numeroAdultos} Adultos ${numeroNinos} Ninos ${numeroHabitaciones} Habitaciones`;
  $templateCarHotel.querySelector(".cards-hoteles__card").setAttribute("data-collectionid", idHotel);
  $templateCarHotel.querySelector(".cards-hoteles__card").setAttribute("data-temporada", temporadaBusqueda);
  $templateCarHotel.querySelector(".cards-hoteles__card").setAttribute("data-petFrendly", 
metacampos.pet_frendly);
  $templateCarHotel.querySelector(".cards-hoteles__card").setAttribute("data-masco", busquedaConMascota);
  $templateCarHotel.querySelector(".cards-hoteles__card").setAttribute("data-collectionname", nombreHotel);
  $templateCarHotel.querySelector(".cards-hoteles__ubicacion").textContent= `${metacampos.location.toUpperCase()}`;
  $templateCarHotel.querySelector(".cards-hoteles__services").textContent= `${metacampos.services.join(", ")}`;
  
  
  let $cloneCard = document.importNode($templateCarHotel, true);
  $fragmentCardHotel.appendChild($cloneCard);
  $contenedor.appendChild($fragmentCardHotel);
 
  
}
const  fechaEsFeriado = (fecha)=> {

        const year = fecha.year();
        const month = fecha.month() + 1;
        const day = fecha.date();

        const diasFeriados = {
          2024: {
           "5":[10,11, 31],
           "6":[1, 7, 8, 29, 30],
           "8":[16,15],
           "10":[11,12],
           "11":[1,2, 8,9],
          },
        };

        if (diasFeriados[year] && diasFeriados[year][month]) {
          if (diasFeriados[year][month].includes(day)) {
            return true; 
          }
        }

        return false; 
      }


const rangoContienePuenteFestivo = (fechaInicio, fechaFin)=> {

        let fechaTemp = moment(fechaInicio);

       while (fechaTemp <= fechaFin) {
          if (fechaEsFeriado(fechaTemp)) {
            return true; // Hay al menos un día festivo en el rango
          }
          fechaTemp = fechaTemp.add(1, "days"); // Avanzar al siguiente día
        }
        return false;
}
//funcion para contar el numero de hoteles
const obtenerNumeroHoteles = (objeto) =>{
  const longitud = Object.keys(objeto).length;
   return longitud;
}

//obtener metacampo de cada hotel
const recorrerMetacampos = async (arrayHotelesHabitaciones, fecha, nombreHotel,  checkout, cantidadMascotas ) =>{

  let cantidadHoteles = obtenerNumeroHoteles(arrayHotelesHabitaciones);
  let tipoBusqueda = document.querySelector(".section-cotizador__select-category");
  
  let busquedaConMascota = false;
  if(window.innerWidth > 1024){
  if(cantidadHoteles >1 && cantidadHoteles < 4){
    let grid = document.querySelector(".cards-hoteles");
    grid.style.setProperty("grid-template-columns",  "repeat(3, 1fr)");
  }else if(cantidadHoteles == 1){
    let grid = document.querySelector(".cards-hoteles");
     grid.style.setProperty("grid-template-columns",  "repeat(1, 1fr)");
     grid.style.setProperty("width",  " 30%");
  }
    
  }
   
  
  let cantidadNoches = obtenerNumeroNoches(fecha, checkout);
   const fechaInicio = moment(fecha.replace(/\//g, "-"));
    const fechaFin = moment(checkout.replace(/\//g, "-"));
   const hotelesExcluidos = new Set(["la_herencia", "cafe_cafe", "combia","loma_verde", "casa_nostra", "la_aldea" ]);
      const hotelesTempMedias= new Set(["paraiso_cafetero", "salento_real", "la_esperanza", "las_camelias", "portal_11","portal_5", "herreria_4", "herreria_20" ]);
  const esPuenteFestivo = rangoContienePuenteFestivo(fechaInicio, fechaFin);
     let finSemana = findeSemana(fecha.replace(/\//g, "-"), checkout.replace(/\//g, "-"));
  
  for(let indice = 0; indice <  nombreHotel.length; indice++){

    const {temporada, metacampos, imagen, id }= await obtenerMetacampos( nombreHotel[indice], fecha,  checkout);
    
  

    if(cantidadMascotas > 0 && !metacampos.pet_frendly ){
      continue;
    }else if(cantidadMascotas > 0 && metacampos.pet_frendly){
      busquedaConMascota=true;
    
    }
    
    if (hotelesExcluidos.has(nombreHotel[indice]) && esPuenteFestivo) {
        
        
      
       if(temporada.temporada.split("_")[1] =="baja" || temporada.temporada.split("_")[1] =="media"){
          temporada.temporada = temporada.temporada.replace("baja", "alta").replace("baja", "media");    
         
       }
       
      
    } 

     if (hotelesTempMedias.has(nombreHotel[indice]) && esPuenteFestivo) {
          if(temporada.temporada.split("_")[1] =="baja"){
               temporada.temporada = temporada.temporada.replace("baja", "media");    
           }
      }

 


     if(nombreHotel[indice] == "botanikal" && !finSemana){
      if(temporada.temporada.split("_")[1] =="alta"){
     
               temporada.temporada = temporada.temporada.replace("alta", "baja");    
           }
    }
 
   let temporadaActu = temporada.temporada.split("_")[1];
   if ((nombreHotel[indice] == "portal_11" || nombreHotel[indice] == "portal_5" || nombreHotel[indice] == "herreria_4" ||
           nombreHotel[indice] == "herreria_20" || nombreHotel[indice] == "herreria_8") && cantidadNoches < 2  && temporadaActu == "media") {
        if(tipoBusqueda.value ="privadas"){
          alert("en esta temporada minimo debes elegir dos noches");
           location.href ="https://turismopanaca.co/pages/viajes-1"
      
          return;
        }
      }

        if ((nombreHotel[indice] == "portal_11" || nombreHotel[indice] == "portal_5" || nombreHotel[indice]== "herreria_4" || nombreHotel[indice] == "herreria_20"
             || nombreHotel[indice] == "herreria_8") && cantidadNoches < 3   && temporadaActu == "alta") {
        if(tipoBusqueda.value ="privadas"){
          alert("en esta temporada se minimo debes elegir tres noches");
           location.href ="https://turismopanaca.co/pages/viajes-1"
       
          return;
        }
      }

       if ((nombreHotel[indice]== "portal_11" ||nombreHotel[indice] == "portal_5" || nombreHotel[indice] == "herreria_4" || nombreHotel[indice] == "herreria_20" || nombreHotel[indice] == "herreria_8") && cantidadNoches < 5) {
       if(tipoBusqueda.value ="privadas"  && temporadaActu == "finAnio"){
          alert("en temporada de fin de año se renta de 5 noches en adelante");
           location.href ="https://turismopanaca.co/pages/viajes-1"
       
          return;
        }
      }

    
   if(temporada.temporada.split("_")[1] =="alta" && cantidadNoches < 3 && nombreHotel[indice] == "las_camelias"){ 
     
      continue;
    }
     if(esPuenteFestivo && cantidadNoches < 3 && nombreHotel[indice] == "las_camelias"){ 
     
      continue;
    }
    
     
    

        if (nombreHotel[indice] == "la_herencia" && esPuenteFestivo &&  cantidadNoches < 2) {
       
         continue;
        } 
  
    obtenerHabitaciones(arrayHotelesHabitaciones[nombreHotel[indice]], temporada, metacampos, imagen, id, busquedaConMascota);
  }
}


//funcion para obtener los hoteles con disponibilidad para la fecha selecionada
const obtenerHotelesDisponbles = async (checkin, checkout, categoria, cantidadMascotas) =>{


   let colecion =  getIdColeccion(categoria);

  try{
    let respuesta = await fetch(URL_DISPONIBILIDAD,
          {
               method: "POST",
               body: JSON.stringify({
                 shop:SHOP,
                 searchDates: `${checkin} to ${checkout}`,
                 filters: {
                    idCollection: colecion,
                    tags: []
                    },
                
               }),
          }
                              
                               
        );

    let json = await respuesta .json();
    let group = await groupRooms(json);
    let keys = await  Object.keys(group);
     recorrerMetacampos(group, checkin, keys, checkout, cantidadMascotas);
    
  }catch(error){
    console.log("ocurrio el siguiente error", error);
      throw error;
  }
  
}

 
 //funcion para ocultar las targetas con los hoteles disponibles
const hiddenCardHotel = () => {
    let $containerCardHotel = document.querySelector('.cards-hoteles');
    $containerCardHotel.style.setProperty('display', 'none');
  }

//funcion para mostrar las targetas con los hoteles disponibles
  const ShowCardHotel = () => {
    let $containerCardHotel = document.querySelector('.cards-hoteles');
    $containerCardHotel.style.setProperty('display', 'grid');
  }

  //funcion para remove parrafo del template 
  const removePragrap = (template) => {
    let element = template.querySelector(".aditional-food");
    if (element) {
      element.remove();
    }
  }

  const createCardRooms = async (room, services, mascotas=false, idHotel, temporada, busConMasco) => {


    const fincaPanacaMedia = [44846373142766,
44845960298734,
44846227095790,
44846348042478,
44846269890798,
44846301774062,
44846269890798];
  const fincaPanacaAlta = [44846373175534,
44845960331502,
44846227128558,
44846348075246,
44846269923566,
44846301806830,
44846269923566];
  const fincaPanacaSupetA = [44846373208302,
45137194057966,
44846227161326,
44846348108014,
44846269956334,
44846301839598,
44846269956334];
    debugger;
    const reserva = JSON.parse(sessionStorage.getItem('reserva')),
        numeroAdultos      = reserva.totalAdultos,
        numeroNinos        = reserva.totalNinos,
        numeroHabitaciones = reserva.acomodacion.length,
        fechaIngreso       = reserva.fechaLlegada,
        fechaEgreso        = reserva.fechaSalida,
        cantidadMascotas   = reserva.numMascotas;
        let precioTotalmascota= 0.0;
        let preciofinal =0;
      if(mascotas){
        let consulta = await obtenerConsulta( idHotel, "custom","propiedahoteles");
        console.log(mascotas);
        let metacampos = await obtenerMetacamposColl(consulta );
        console.log(metacampos.data.collection.metafields);
        let datosHotel = metacampos.data.collection.metafields[0].value;
        let json = await JSON.parse(datosHotel);
        let precioMascota = json.price_pet_frendly;
        
     
           if((metacampos.data.collection.title == "Portal 5" || metacampos.data.collection.title == "Portal 11" 
            || metacampos.data.collection.title == "Herreria 20" || metacampos.data.collection.title == "Herreria 4" ||  metacampos.data.collection.title == "Herreria 8") && temporada =="baja"){
              precioMascota = 35000.0;
            }

           if((metacampos.data.collection.title == "Portal 5" || metacampos.data.collection.title == "Portal 11" 
            || metacampos.data.collection.title == "Herreria 20" || metacampos.data.collection.title == "Herreria 4" || metacampos.data.collection.title == "Herreria 8") && temporada =="media"){
           precioMascota = 40000.0;
            }
        
           if((metacampos.data.collection.title == "Portal 5" || metacampos.data.collection.title == "Portal 11" 
            || metacampos.data.collection.title == "Herreria 20" || metacampos.data.collection.title == "Herreria 4" || metacampos.data.collection.title == "Herreria 8") && temporada =="finAnio"){
          precioMascota = 0.0;
            }

          precioTotalmascota = precioMascota  * room.hotelNight * cantidadMascotas;
        
      }
      
    let $edadesNinos = document.querySelectorAll(".section_ages-child");
    

    let variantes = room.variant[0].length;
   
   
    for (let indicativo = 0; indicativo < variantes; indicativo++) {
      let total = 0,
    idVariants = [];
    let priceString=0;

      for (let indice = 0; indice < room.variant.length; indice++) {
        total += room.variant[indice][indicativo].price * room.hotelNight;
        idVariants.push(room.variant[indice][indicativo].id);
      }

     const  $templateBooking = document.querySelector("#template-booking").content;

     

     
      if(room.hotelName == "birdglam_los_arboles"  &&  room.hotelNight ==1 && idVariants.includes(45145671532782)){
    
        continue;
      }
      if( room.hotelName == "birdglam_los_arboles"&& numeroAdultos== 2 && numeroNinos == 0 && idVariants[0] ==44249336807662 &&  room.hotelNight == 1){
        continue;
      }

       if( room.hotelName == "birdglam_los_arboles"&& numeroAdultos== 2 && numeroNinos == 0 && idVariants[0] ==44249336807662 &&  room.hotelNight == 1){
        continue;
      }
       if( room.hotelName == "birdglam_los_arboles"&& numeroAdultos== 2 && numeroNinos == 0 && idVariants[0] ==44249336807662 &&  room.hotelNight == 1){
        continue;
      }
       if( room.hotelName == "birdglam_los_arboles"&& numeroAdultos== 2 && numeroNinos == 0 && idVariants[0] ==44249336807662 &&  room.hotelNight == 1){
        continue;
      }

      if(room.hotelName == "birdglam_los_arboles"  &&  room.hotelNight == 2){
        if(idVariants.includes(44241303568622)){
          let variantebuscada =  idVariants.indexOf(44241303568622);
            idVariants[variantebuscada] = 45075541950702;
          priceString += 178100000;
        }
       
        if(idVariants.includes(44249336774894)){
          let variantebuscada =  idVariants.indexOf(44249336774894);
            idVariants[variantebuscada] = 45075542016238;
           priceString +=117900000 ;
        }
        if(idVariants.includes(45145671532782)){
          let variantebuscada =  idVariants.indexOf(45145671532782);
            idVariants[variantebuscada] = 45075541983470;
           priceString +=190600000;
        }
      if(idVariants.includes(44241287610606)){
          let variantebuscada =  idVariants.indexOf(44241287610606);
            idVariants[variantebuscada] = 45143691919598;
           priceString += 237900000;
        }
        if(idVariants.includes(45145066537198)){
          let variantebuscada =  idVariants.indexOf(45145066537198);
            idVariants[variantebuscada] = 45143691952366;
           priceString += 250400000;
        }
         if(idVariants.includes(44241283317998)){
          let variantebuscada =  idVariants.indexOf(44241283317998);
            idVariants[variantebuscada] = 45143710662894;
           priceString += 297700000;
        }
        
        if(idVariants.includes(45145731662062)){
          let variantebuscada =  idVariants.indexOf(45145731662062);
            idVariants[variantebuscada] = 45143710695662;
           priceString += 310200000;
        }

       if(idVariants.includes(45006793015534)){
          let variantebuscada =  idVariants.indexOf(45006793015534);
            idVariants[variantebuscada] = 45143817912558;
           priceString += 370000000;
        }

          if(idVariants.includes(45006802944238)){
          let variantebuscada =  idVariants.indexOf(45006802944238);
            idVariants[variantebuscada] =45143820697838;
           priceString += 429800000;
        }
                           
              
    priceString = priceString.toString();
      }
        else if(room.hotelName == "birdglam_los_arboles"  &&  room.hotelNight > 2){
               if(idVariants.includes(44241303568622)){
          let variantebuscada =  idVariants.indexOf(44241303568622);
            idVariants[variantebuscada] = 45075541950702;
          priceString += 178100000 + (89100000 * (room.hotelNight -2));
                
        }
       
        if(idVariants.includes(44249336774894)){
          let variantebuscada =  idVariants.indexOf(44249336774894);
            idVariants[variantebuscada] = 45075542016238;
           priceString += 117900000+ (59200000 * (room.hotelNight -2));
        }
        if(idVariants.includes(45145671532782)){
          let variantebuscada =  idVariants.indexOf(45145671532782);
            idVariants[variantebuscada] = 45075541983470;
           priceString += 190600000 + (78600000 * (room.hotelNight -2));
        }
      if(idVariants.includes(44241287610606)){
          let variantebuscada =  idVariants.indexOf(44241287610606);
            idVariants[variantebuscada] = 45143691919598;
           priceString += 178100000 +(29900000 * room.hotelNight * 1 )+(89100000*(room.hotelNight -2));
        
        }
        if(idVariants.includes(45145066537198)){
          let variantebuscada =  idVariants.indexOf(45145066537198);
            idVariants[variantebuscada] = 45143691952366;
           priceString += 190600000 +(29900000 * room.hotelNight *  1 )+(78600000*(room.hotelNight -2));
        }
         if(idVariants.includes(44241283317998)){
          let variantebuscada =  idVariants.indexOf(44241283317998);
            idVariants[variantebuscada] = 45143710662894;
          priceString += 178100000 +(29900000 * room.hotelNight * 2 )+(89100000*(room.hotelNight -2));
        }
        
        if(idVariants.includes(45145731662062)){
          let variantebuscada =  idVariants.indexOf(45145731662062);
            idVariants[variantebuscada] = 45143710695662;
          priceString += 190600000 +(29900000 * room.hotelNight *2 )+(78600000*(room.hotelNight -2));
        }

       if(idVariants.includes(45006793015534)){
          let variantebuscada =  idVariants.indexOf(45006793015534);
            idVariants[variantebuscada] = 45143817912558;
          priceString += 190600000 +(29900000 * room.hotelNight *3 )+(78600000*(room.hotelNight -2));
        }

          if(idVariants.includes(45006802944238)){
          let variantebuscada =  idVariants.indexOf(45006802944238);
            idVariants[variantebuscada] =45143820697838;
            priceString += 190600000 +(29900000 * room.hotelNight *4 )+(78600000*(room.hotelNight -2));
        }
           priceString = priceString.toString();
        }else{
          priceString =  total.toString();
        }

      if(precioTotalmascota > 0){
       
         preciofinal = parseFloat(priceString.slice(0, priceString.length - 2)) + parseFloat(precioTotalmascota);
      }else{
        preciofinal = parseInt(priceString.slice(0, priceString.length - 2));
      }
     let price = formatPrecios(preciofinal);

      removePragrap($templateBooking, $templateBooking);
      removeServices($templateBooking.querySelector('.card-booking__services'));
      addServicesRoom(services, $templateBooking.querySelector('.card-booking__services'));
      $templateBooking.querySelector(".card-booking__img").srcset = `https://cdn.shopify.com/s/files/1/0654/4562/6094/${room.image}`;
      $templateBooking.querySelector(".card-booking__source").src = `https://cdn.shopify.com/s/files/1/0654/4562/6094/${room.image}`;
      $templateBooking.querySelector(".card-booking__h3").innerHTML = `<b>Hotel ${room.hotelName.replaceAll('_', ' ')}</b>`;
      let priceSimple = getPriceVariant(room, room.hotelNight).toString(),
        priceFormat = formatPrecios(parseInt(priceSimple.slice(0, priceSimple.length - 2)))
      $templateBooking.querySelector(".card-booking__price").innerHTML = `${price}`;
      $templateBooking.querySelector(".card-booking__description").textContent = `${numeroAdultos} Adultos ${numeroNinos} niños ${numeroHabitaciones} habitaciones`;
      $templateBooking.querySelector('.card-booking').setAttribute('data-variants', idVariants);
       $templateBooking.querySelector('.card-booking').setAttribute('data-idhotel', idHotel);
      $templateBooking.querySelector('.card-booking').setAttribute('data-mascota', busConMasco);
      $templateBooking.querySelector('.card-booking').setAttribute('data-temporada', temporada);
      $templateBooking.querySelector('.card-booking').setAttribute('data-hotel', room.hotelName);
      $templateBooking.querySelector(".card-booking__paragraph-info").innerHTML = `<b>${room.hotelNight} Noches / ${parseInt(numeroNinos) + parseInt(numeroAdultos )} huéspedes</b>`;
      $templateBooking.querySelector(".card-booking__paragraph-checkin").innerHTML = `<b>Fecha De Llegada:</b> ${fechaIngreso.replaceAll("-", " | ") } `;
      $templateBooking.querySelector(".card-booking__paragraph-checkout").innerHTML = `<b>Feha De Salida:</b>  ${fechaEgreso.replaceAll("-", " | ") }`;
      if(room.hotelName == "herreria_4" || room.hotelName == "herreria_8" || room.hotelName == "portal_5"  || room.hotelName == "portal_11"  ){
           $templateBooking.querySelector(".card-booking__paragraph-habitacion").textContent = `Número habitaciones ${room.variant[0][indicativo].title.split('/')[2]??''}`;
      }else{
        
      $templateBooking.querySelector(".card-booking__paragraph-habitacion").textContent = `habitacion ${room.variant[0][indicativo].title.split('/')[2]??''}`;
      }
      
      let $paragraph = document.createElement("p");
      let $tipoHabitacion = document.createElement("p");
      $paragraph.classList.add("aditional-food");

      $paragraph.textContent = `${room.variant[0][indicativo].title.split('/')[1]??''}`;
   
      $templateBooking.querySelector(".card-booking__paragraph-info").insertAdjacentElement('afterend', $paragraph);
   

      let clone = document.importNode($templateBooking, true);
      let newPadre = document.querySelector("#container-rooms");
      newPadre.style.setProperty('display', 'flex');
      newPadre.appendChild(clone);

    }



  }

       //funcion para obtener la variante del la estadia de la mascota segun la temporada
  const getVariantMascota = async (idProducto) =>{
     let teporada = document.querySelector(".card-booking").getAttribute("data-temporada");
     let consulta = await obtenerConsultaProducto(idProducto);
     let variantes =  await obtenerMetacamposColl(consulta);
     let varianteTemporada =  variantes.data.product.variants.edges.find((producto)=>producto.node.title == teporada)
     return varianteTemporada.node.id.split("/")[4];
    
  }
    //funcion para obtener el array con las habitaciones selecionadas
  const getVariantHotelSelect = (element) => {
    const hotelSlect = element.closest('.cards-hoteles__card'),
          hotelName = hotelSlect.getAttribute('data-collectionname'),
          hotelId = hotelSlect.getAttribute('data-collectionid'),
          hotelSelect = hotels.find((hotel) => hotel.hotelName == hotelName),
          services = hotelSlect.querySelectorAll('.cards-hoteles__services'),
          mascotas = hotelSlect.getAttribute("data-petfrendly"),
          busConMasco =  hotelSlect.getAttribute("data-masco"),
          temporada = hotelSlect.getAttribute("data-temporada");
          let cantidadMascotas =0; 
        
        
    
          

          createCardRooms(hotelSelect, services, mascotas,  hotelId, temporada,  busConMasco );

     // document.getElementById('idFilter__visit').style.display = 'none';
  }

  const obtenerCantidadElementos = async () =>{

    let containerTotal = document.querySelector(".carrito-cantidad");
    let response = await fetch("/cart.js");
    let json = await response.json();
    containerTotal.textContent = json.item_count;
     containerTotal.style.setProperty("display", "flex");
  }
  const sendToCardS = async (rooms) => {

 console.log("restaurando el carrito", rooms);
    const lines = rooms.map((item) => {
            const attributes = Object.entries(item.properties).map(([key, value]) => ({
                      key,
                      value,
                  }));

            return {
                  merchandiseId: `gid://shopify/ProductVariant/${item.id}`,
                quantity: parseInt(item.quantity), 
                attributes, 
            };
          });

     let resuesta = await agregarItemsAlCarrito(lines);
 
    if(resuesta.length > 0){
       const $productosCarrito = document.querySelector(".__count");
       
      if($productosCarrito){
          $productosCarrito.removeAttribute('hidden');
        
        }

          obtenerCantidadElementos();
          createAlert('Habitaciones agregadas al carrito');
               
          
        }
    
  }

async function crearCarritoInicial(){

  try{
     let response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(arreglo)
        });
    
  }catch(error){
    console.log("ocurrio este error al intentar agregar")
  }
}

const obtenerIdCarrito = async () => {
  
  await crearCarritoInicial();

  let idSesion = ""; 

  try {
    
    const response = await fetch("/cart.js");

    if (!response.ok) {
      throw new Error(`Error en la petición: ${response.status}`);
    }

    
    const json = await response.json();


      idSesion = `gid://shopify/Cart/${json.token}`;
   return idSesion;
  } catch (error) {
    console.error("Ocurrió el siguiente error al obtener el carrito:", error);
  }

 
  return idSesion;
};


  async function agregarItemsAlCarrito(lineasProducto){
    const cartId = await obtenerIdCarrito(); 
    
    const variables ={
      cartId,
      lines: lineasProducto
    };

    
   let consulta = await  agregaProductosAlCarrito(cartId, lineasProducto);
    
   let respuesta = await ejecutarConsulta(consulta, variables);
    
    

  console.log("la respuesta",  respuesta.data.cartLinesAdd.cart.lines.edges);

    return respuesta.data.cartLinesAdd.cart.lines.edges;
  }
  


 //funcion para obtener las variantes y la cantida a enviar al carrito
  const varianToCard = async (varians, night, name, mascota) => {
    
    let SEGURO_HOTELERO = 45058060845294;
    let variantsRooms = [],
        variants = varians.split(',');

    
    const reserva = JSON.parse(sessionStorage.getItem('reserva')),
        numeroAdultos      = reserva.totalAdultos,
        numeroNinos        = reserva.totalNinos,
        numeroHabitaciones = reserva.acomodacion.length,
        fechaIngreso       = fechaAnioMesDia(reserva.fechaLlegada),
        fechaEgreso        = fechaAnioMesDia(reserva.fechaSalida);
    const totalSeguro =  (parseInt(numeroAdultos) + parseInt(numeroNinos))* night;
    
   
    if(name == "la_esperanza" || name == "paraiso_cafetero"){
      let totalSeguro = parseInt(numeroNinos) * night;
      variantsRooms.push({
        id: 45058060845294,
        quantity: totalSeguro,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `Seguro hotelero niños`,

        },
        
      });
    }

    if(name == "birdglam_los_arboles" && night > 2 ){
       
      if(variants.includes("45075541950702")){
         variantsRooms.push({
        id: 45075541950702,
        quantity: 1,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },

      {
        id: 45075574784238,
        quantity: (night -2),
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },
                           
                           
      );
        
      }else if(variants.includes("45075542016238")){
                variantsRooms.push({
        id: 45075542016238,
        quantity: 1,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },

      {
        id: 45075574849774,
        quantity: (night -2),
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },
                           
                           
      );
      }else if(variants.includes("45075541983470")){
        variantsRooms.push({
        id: 45075541983470,
        quantity: 1,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },

      {
        id:45075574817006 ,
        quantity: (night -2),
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },
                           
                           
      );
      }else if(variants.includes("45143691919598")){

           variantsRooms.push({
        id: 45075541950702,
        quantity: 1,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },

      {
        id: 45075574784238,
        quantity: (night -2),
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

        

      },
      {
        id: 45151435784430,
        quantity: night,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

        

      },                        
                           
                           
      );
      }else if(variants.includes("45143691952366")){
        variantsRooms.push({
        id:45075542016238 ,
        quantity: 1,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },

      {
        id: 45075574849774,
        quantity: (night -2),
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },
                           
     {
        id: 45151435784430,
        quantity: night,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

        

      },                           
      );
        
      }else if(variants.includes("45143710662894")){

          variantsRooms.push({
        id: 45075541950702,
        quantity: 1,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },

      {
        id: 45075574784238,
        quantity: (night -2),
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },
          {
        id: 45151435784430,
        quantity: night*2,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

        

      },                        
                           
      );
      }else if(variants.includes("45143710695662" )){

          variantsRooms.push({
        id: 45075542016238,
        quantity: 1,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },

      {
        id: 45075574849774,
        quantity: (night -2),
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },
                           
       {
        id: 45151435784430,
        quantity: night*2,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

        

      },                                 
      );
      }else if(variants.includes("45143817912558" )){
                 variantsRooms.push({
        id: 45075542016238,
        quantity: 1,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },

      {
        id: 45075574849774,
        quantity: (night -2),
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },
       {
        id: 45151435784430,
        quantity: night*3,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

        

      },                     
                           
      );
      }else if(variants.includes("45143820697838" )){
         variantsRooms.push({
        id: 45075542016238,
        quantity: 1,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },

      {
        id: 45075574849774,
        quantity: (night -2),
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      },
        {
        id: 45151435784430,
        quantity: night*4,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

        

      },                    
                           
      );
      }
      
     

        
      
    }else{

    for (let index = 0; index < variants.length; index++) {
      variantsRooms.push({
        id: parseInt(variants[index]),
        quantity: night,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'hotel',
          'hotel': `${name}`,

        },

      });
    }
      
    }
    if(mascota == true){
   console.log("llego mascota valor", mascota);
      const reserva = JSON.parse(sessionStorage.getItem('reserva')),
            cantidadMascotas   = reserva.numMascotas,
            idCollection = "gid://shopify/Collection/"+ document.querySelector(".card-booking").getAttribute("data-idhotel");
           
            let consulta = await obtnerMetacamposCollection(idCollection, "custom", "mascotas");
                 let response = await obtenerMetacamposColl(consulta);
     
                 let idmascotas = await response.data.collection.metafields[0].value;
                 let idhospedajeMascota = await  getVariantMascota(idmascotas);
                  let totalNochesMascotas = cantidadMascotas * night;

                 variantsRooms.push({
                        id: parseInt(idhospedajeMascota),
                        quantity: totalNochesMascotas ,
                       properties: {
                      'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
                       'group': 'hotel',
                       'hotel': `${name}`,
                     },

      });
                 //json = response.json();
      
    }

     variantsRooms.push({
        id: 45346462171374,
        quantity: totalSeguro,
        properties: {
          'fecha': `${ fechaIngreso}| ${fechaEgreso}`,
          'group': 'poliza',
          'hotel': `poliza `,

        },
        
      });
    console.log("se enviara", variantsRooms)
    sendToCardS(variantsRooms)

  }
//funcion para enviar al carrito de compras
  const sendTocart = (element) => {
    let $card = element.closest('.card-booking'),
      $cards = [...document.querySelectorAll('.card-booking')],
      $cardSelected = $cards.indexOf($card),
      mascotas = $card.getAttribute("data-mascota"),
      $variantSelected = element.closest('.card-booking'),
       totalMascota = 0,
      $selected = hotels.find((hotel) => hotel.hotelName == $card.getAttribute('data-hotel'));
       console.log("las mascotas son ", mascotas);
      if(mascotas){
        totalMascota =  document.querySelector(".section-mascotas_input-total");
      }

    
    varianToCard($variantSelected.getAttribute('data-variants'), $selected.hotelNight, $card.getAttribute('data-hotel'), mascotas, totalMascota);
  }
  

 (()=>{
   document.addEventListener('click', (evento)=>{
  
    const $containerRoom = document.querySelector(".section-desplegables");
    if (event.target.closest(".cards-hoteles__card")) {
        showLoading();
        $containerRoom.classList.remove("section-desplegables__visible");
        hiddenCardHotel();
        showTitleHotel();
  
        createMainImage(event.target);
        createImagenGallery(event.target)
        getVariantHotelSelect(event.target);
        snapCarousel();
        moveImagenes();

      }

     if(evento.target.matches('.card-booking__send')){
       
          sendTocart(event.target);
     }
    
  });
  })();

 
obtenerParametros(obtenerHotelesDisponbles);
 